import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cec-cfs-first-fit',
  templateUrl: './cec-cfs-first-fit.component.html',
  styleUrls: ['./cec-cfs-first-fit.component.scss']
})
export class CecCfsFirstFitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
